<script>
    import CardCinema from "../components/CardCinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /**
 *
 */
    let {
        contextDresonRule,
        removeSkeleton,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth,
        featureIndex,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let recommendations = $state(),
        additionalClickTracking = $state(),
        tracking = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    const site = "reco_deals";

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/deals?encodedDresonRule=${contextDresonRule}`);
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            recommendations,
            featuresState,
            additionalClickTracking,
            tracking,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_card_cinema_wrapper">
        <CardCinema
            {recommendations}
            {performance}
            {cinemaInjectionContainerWidth}
            additionalCinemaClickTracking={additionalClickTracking}
            {featuresState}
            {featureIndex}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            {tracking}
            personalisedUser={hasPersonalisedRecommendations}
            {site}
            hasElevationLevel={true}
            initialTrackingStatus="hidden"
        />
    </div>
{/if}

<style lang="scss">
    .reco_card_cinema_wrapper {
        max-height: 672px;
        position: relative;
    }
</style>
